import { Tabs } from '@eds-web/react';
import styled from '@emotion/styled';
import { device } from '../../constants/breakpoint';

export const StyledCompetitiveTabs = styled(Tabs)`
    gap: 24px;

    @media screen and ${device.laptop} {
        gap: 16px;
        & > div {
            flex-wrap: inherit !important;
            max-width: 100%;
            box-sizing: border-box;
        }
    }

    @media screen and ${device.mobile} {
        gap: 12px;
        max-width: 100%;

        & > div:first-of-type {
            flex-wrap: wrap;
            gap: 8px;
        }

        & button {
            min-width: auto;
            padding: 8px 12px;
            font-size: 14px;
        }
    }
`;
